import script from "./PreviewVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewVideo.vue?vue&type=script&setup=true&lang=js"

import "./PreviewVideo.vue?vue&type=style&index=0&id=0cbe430d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.69.1_uglify-js@3.15.2_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cbe430d"]])

export default __exports__